import { Drawer, Grid } from 'antd'
import { SubscriberCardBody, type Mode } from './SubscriberCardBody'
import type { DirectoryRow } from './cashdeskApi'
import type { CashPlan } from './cashdeskPlans'
import type { Money } from '@/shared/lib/money'
import type { CashierState } from './useCashier'

interface SubscriberCardDrawerProps {
  row: DirectoryRow | null
  cashier: CashierState
  plans: readonly CashPlan[]
  /** KANONIK paket nomi → narx; tez to'ldirish tugmalari shundan */
  priceByName: ReadonlyMap<string, Money>
  /** «Abonentlar» havolasi darhol ochadigan panel — `SubscriberCardBody` */
  initialMode?: Mode | null
  onShowHistory?: (() => void) | null
  onClose: () => void
}

/**
 * Abonent kartochkasining QOBIG'I — suzuvchi panel.
 *
 * <h2>⚠️ KENG EKRANDA UMUMAN CHIZILMAYDI</h2>
 * `docs/11 §4.1` keng ekranda ikki ustunni talab qiladi va 2026-08-20
 * dan buyon `CashdeskPage` aynan shuni chizadi: `lg` dan keng oynada
 * kartochka o'ng ustunda `SubscriberCardBody` bo'lib turadi va bu
 * komponent umuman ishlatilmaydi. Ilgari butun ish oqimi (kartochka →
 * summa → tasdiq → natija) ekranning o'ng chekkasidagi 460px lik
 * chiziqda kechardi, qolgan ~1400px esa niqob ostida qorayib turardi.
 *
 * <h2>⚠️ Telefonda PASTDAN chiqadi</h2>
 * `placement="bottom"` — bosh barmoq yetadigan joy ekranning pastki
 * uchdan biri; o'ng tomondan chiqadigan panelda amal tugmalari yuqorida
 * qolib, telefonni qo'lda surib ushlashni talab qilardi. `md` va `lg`
 * oralig'idagi tor kompyuter oynasida esa o'ng panel qoladi — u yerda
 * ikki ustunga joy yo'q, lekin barmoq ham ishlatilmaydi.
 *
 * <h2>⚠️ `destroyOnHidden` SAQLANDI</h2>
 * Yopilganda ich butunlay yo'q qilinadi va keyingi ochilishda toza
 * mount bo'ladi — pul panellarining holati oldingi abonentdan
 * qolmasin.
 */
export function SubscriberCardDrawer({
  row,
  cashier,
  plans,
  priceByName,
  initialMode = null,
  onShowHistory = null,
  onClose,
}: SubscriberCardDrawerProps) {
  const screens = Grid.useBreakpoint()
  const isMobile = screens.md === false

  return (
    <Drawer
      open={row !== null}
      onClose={onClose}
      placement={isMobile ? 'bottom' : 'right'}
      {...(isMobile ? { height: '92%' } : { width: 460 })}
      title={row?.login ?? ''}
      destroyOnHidden
      styles={{ body: { paddingTop: 12 } }}
    >
      {row === null ? null : (
        <SubscriberCardBody
          row={row}
          cashier={cashier}
          plans={plans}
          priceByName={priceByName}
          initialMode={initialMode}
          onShowHistory={onShowHistory}
        />
      )}
    </Drawer>
  )
}
